import { useQuery } from '@tanstack/react-query'
import { EntityWithIdAndDescription, SectorComercial, UnidadNegocio } from '../../../../../types'
import { HttpCacheOperacion } from '../../../api/httpCacheOperacion'
import { OperacionLCLSHPTILimiteTipo } from '../types/dto'

export const useLCSLHPTIUnidadNegocioTipos = (codPais: number | undefined | null, codSistema: number | undefined | null) => {
    const {
        data: unidadNegocioTipos = [],
        isLoading,
        isError,
        error
    } = useQuery<UnidadNegocio[], Error>({
        queryKey: ['LCSLHPTI-unidad-negocio-tipos', codPais, codSistema],
        queryFn: () => HttpCacheOperacion.getUnidadesNegocioPorPaisYSistema(codPais!, codSistema!),
        enabled: !!codPais && !!codSistema
    })

    return {
        unidadNegocioTipos,
        isLoading,
        isError,
        error
    }
}

export const useLCSLHPTISectorComercialTipos = (codUnidadNegocio: number | undefined | null, codSistema: number | undefined | null) => {
    const {
        data: sectorComercialTipos = [],
        isLoading,
        isError,
        error
    } = useQuery<SectorComercial[], Error>({
        queryKey: ['LCSLHPTI-sector-comercial-tipos', codUnidadNegocio, codSistema],
        queryFn: () => HttpCacheOperacion.getSectoresComercialesPorUnidadNegocio(codUnidadNegocio!, codSistema!),
        enabled: !!codUnidadNegocio && !!codSistema
    })

    return {
        sectorComercialTipos,
        isLoading,
        isError,
        error
    }
}

export const useLCSLHPTILimiteTipos = () => {
    const {
        data: limiteTipos = [],
        isLoading,
        isError,
        error
    } = useQuery<OperacionLCLSHPTILimiteTipo[], Error>({
        queryKey: ['LCSLHPTI-limite-tipos'],
        queryFn: () => HttpCacheOperacion.getLCSLHPTILimiteTipos()
    })

    return {
        limiteTipos,
        isLoading,
        isError,
        error
    }
}

export const useLCSLHPTILimiteAgregadoTipos = () => {
    const {
        data: limiteAgregadoTipos = [],
        isLoading,
        isError,
        error
    } = useQuery<OperacionLCLSHPTILimiteTipo[], Error>({
        queryKey: ['LCSLHPTI-limite-agregado-tipos'],
        queryFn: () => HttpCacheOperacion.getLCSLHPTILimiteAgregadoTipos()
    })

    return {
        limiteAgregadoTipos,
        isLoading,
        isError,
        error
    }
}

export const useLCSLHPTILimiteHoldingTipos = () => {
    const {
        data: limiteHoldingTipos = [],
        isLoading,
        isError,
        error
    } = useQuery<EntityWithIdAndDescription[], Error>({
        queryKey: ['LCSLHPTI-limite-holding-tipos'],
        queryFn: () => HttpCacheOperacion.getLCSLHPTILimiteHoldingTipos()
    })

    return {
        limiteHoldingTipos,
        isLoading,
        isError,
        error
    }
}

export const useLCSLHPTIConcentracionTipos = () => {
    const {
        data: concentracionTipos = [],
        isLoading,
        isError,
        error
    } = useQuery<EntityWithIdAndDescription[], Error>({
        queryKey: ['LCSLHPTI-concentracion-tipos'],
        queryFn: () => HttpCacheOperacion.getLCSLHPTIConcentracionTipos()
    })

    return {
        concentracionTipos,
        isLoading,
        isError,
        error
    }
}

export const useLCSLHPTILimitePerdidaTipos = () => {
    const {
        data: limitePerdidaTipos = [],
        isLoading,
        isError,
        error
    } = useQuery<EntityWithIdAndDescription[], Error>({
        queryKey: ['LCSLHPTI-limite-perdida-tipos'],
        queryFn: () => HttpCacheOperacion.getLCSLHPTILimitePerdidaTipos()
    })

    return {
        limitePerdidaTipos,
        isLoading,
        isError,
        error
    }
}